
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.939 10.771a.914.914 0 110 1.829.914.914 0 010-1.829zm.004-7.37c.473 0 .857.383.857.856v4.286a.857.857 0 01-1.714 0V4.257c0-.473.383-.857.857-.857z","fill":"#FFF"}})])])
          )
        }
      }
    